import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-twitter',
    templateUrl: './twitter.component.html',
    styleUrls: ['./twitter.component.scss'],
    standalone: true
})
export class TwitterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
